import React, { Component } from 'react';
import { BsyUtils } from '../../../utils/Utils';

class SearchDash extends Component {

    constructor(props) {
        super(props);
        this.state = {
            appMaps: [],
            block: props.block
        }
    }
    onSelectEntry = (entry) => {
        const { appMaps } = this.state;
        if (!entry) {
            return;
        }

        let _id = [entry.appId, entry.entryId].join('@');

        if (appMaps[_id]) {
            const newAppMap = {
                ...appMaps,
                [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
            }
            this.setState({
                appMaps: newAppMap,
            })
            return;
        }
        React.axios('/dashboard/app/' + entry.appId + '/entry/' + entry.entryId).then(res => {

            let components = [];
            // console.log(res.data.entry.components);
            BsyUtils.forEach(res.data.entry.components, (dd, data) => {
                if (data.type.indexOf('filter') > -1) {
                    // console.log('data is   ' + data.type)
                    return;
                }
                if (data.type.indexOf('description') > -1) {
                    // console.log('data is   ' + data.type)
                    data.listName = React.language('dash.descriptionBtn')
                }
                if (data.type.indexOf('image') > -1) {
                    // console.log('data is   ' + data.type)
                    data.listName = React.language('dash.image')
                }
                if (data.type.indexOf('real_time') > -1) {
                    // console.log('data is   ' + data.type)
                    data.listName = React.language('dash.real.time')
                }
                if (data.type.indexOf('embedded_iframe') > -1) {
                    // console.log('data is   ' + data.type)
                    data.listName = React.language('dash.embedded.iframe')
                }
                if (data.type.indexOf('filte_quick') > -1) {
                    data.listName = React.language('dash.filter.quick')
                }
                if (data.type.indexOf('base_layout_container') > -1) {
                    // console.log('data is   ' + data.type)
                    data.listName = React.language('dash.embedded.layout.container')
                }
                components.push({ ...data, appId: entry.appId, entryId: entry.entryId })
            })

            // for (let data in res.data.entry.components) {

            //     if (typeof res.data.entry.components[data] == 'funciton') {
            //         console.log('data is function ')
            //         continue;
            //     }
            //     if (!res.data.entry.components[data]) {
            //         console.log('data is null ')
            //         continue;
            //     }
            //     if (res.data.entry.components[data].type.indexOf('filter') > -1) {
            //         console.log('data is   ' + res.data.entry.components[data].type)
            //         continue;
            //     }
            //     if (res.data.entry.components[data].type.indexOf('description') > -1) {
            //         console.log('data is   ' + res.data.entry.components[data].type)
            //         res.data.entry.components[data].listName = React.language('dash.descriptionBtn')
            //     }

            //     components.push({ ...res.data.entry.components[data], appId: entry.appId, entryId: entry.entryId })
            // }

            const newAppMap = {
                [_id]: { components: components, open: true },
                ...appMaps,
            }
            this.setState({
                appMaps: newAppMap,
            })

        }).catch(res => {
            console.log(res)
        })
    }

    componentsAdd = (component) => {
        const { block } = this.state;
        const { componentsAdd } = this.props;
        this.component = { ...component }
        this.setState({
            block: {
                ...block,
                appId: component.appId,
                entryId: component.entryId,
                widgetId: component.widgetId,
                name: component.title,
            },
        }, () => {
            componentsAdd(component)
        })
    }

    renderComponentlist = (appInfo) => {
        const { appMaps, block } = this.state;
        const { findEntryS } = this.props;

        let _id = [appInfo.appId, appInfo.entryId].join('@');

        if (appMaps[_id]) {

            if (!appMaps[_id].open) {
                return '';
            }

            let components = appMaps[_id].components.filter((item,key) => {
                return item.type !== "base_layout_container"
            });
            return <div className='dash-components' >
                {
                    components.length === 0 ? <div className="components-item empty"><span className="entry-title">当前应用没有可使用报表</span></div> :
                        components.map((data, index) => {
                            return <div className={'components-item'} onClick={e => { e.stopPropagation(); !findEntryS(data) && this.componentsAdd(data) }} >
                                <span className={'entry-title'}>{data.title || data.listName}</span>
                                <span className={'right-entry-title'}>{
                                    findEntryS(data)
                                        ? <span className='read-tip'>{React.language('add.already')}</span>
                                        : [data.appId, data.entryId, data.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@") ? <i className='icon-ok' /> : ''
                                }</span>
                            </div>
                        })
                }
            </div>
        } else {
            return '';
        }
    }

    render() {
        const { otherItem, res, block, findEntryS } = this.props
        return (
            res && res.length > 0 ? <div className="searchDash">
                <ul className="searchCont">
                    {
                        otherItem.length > 0 ? otherItem.map((val) => {
                            return val && <li key={val._id}>
                                <div className="contView" onClick={e => { this.onSelectEntry(val) }}>
                                    <div className="menu-item" title={val.name}>
                                        <i className={`node-icon icon-bsy-${val.type}${!val.hasCoop ? "-flow" : ""} ${val.icon<=24?`icon-bsy-form-${val.icon}`:`icon-new-bsy-form-${val.icon}`}`} />
                                        <span dangerouslySetInnerHTML={{ __html: val.titleHtml }} />
                                        <span className={'right-entry-title'}>{
                                            findEntryS(val)
                                                ? <span className='read-tip'>{React.language('add.already')}</span>
                                                : [val.appId, val.entryId, val.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@") ? <i className='icon-ok' /> : ''
                                        }</span>
                                    </div>
                                    <div className="appNameItem">
                                        <span>{val.appName}</span>
                                    </div>
                                </div>
                                {
                                    this.renderComponentlist(val)
                                }
                            </li>
                        }) : <li className="emptySearchForm">
                            {React.language('dash.form.empty')}
                        </li>
                    }
                </ul>
            </div> : <div className="emptySearchAll">
                {React.language('field.location.empty')}
            </div>
        );
    }
}

export default SearchDash;